// src/components/Header.js
import { NavLink } from "react-router-dom";
import './styles/Header.css';
import logo from '../assets/EA_logo.svg';

function Header() {
  return (
    <header className="site-header">
      <div className="container header-container">
        <NavLink to="/" className="logo-link">
          <img src={logo} alt="Elamuaudit OÜ" className="logo" />
        </NavLink>
        <nav className="nav-menu">
          <a href="#contact">Kontakt</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;
